import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link, StoryElement, WithHostUrl, SocialShare } from "@quintype/components";
import { WebEngage, GA, PGAD, DeepBI } from "../../../integrations";
import Navbar from "../../atoms/secondary-menu";
import Icon, { ZodiacIcon } from "../../atoms/icon";
import { PAGE_TYPE } from "../../../constants";
import styles from "./styles.m.css";
import { VikatanSticky, PGAdwithAd } from "../../rows/ad-free";
import Media from "react-media";
import Tags from "../story/story-templates/shared/tags";
import AuthorDetail from "../story/story-templates/shared/author-detail";
import { humanizeDate } from "../../utils/time-format";
import { MgidUnderArticleAd } from "../../atoms/mgid-2025/underArticle";
import { SocialShareTemplate } from "../story/story-templates/shared/social-share";

const ALMANAC_HEADLINE = "பஞ்சாங்கம்";

export class RasipalanDetailPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedZodiac: "aries",
      isDropdownOpen: false,
      horoscopeName: { rasipalan: "Daily", "monthly-rasipalan": "Month", "weekly-rasipalan": "Weekly" }
    };
    this.selectZodiac = this.selectZodiac.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  selectZodiac(type) {
    this.setState({ selectedZodiac: type, isDropdownOpen: false });
  }

  toggleDropdown() {
    this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
  }

  componentDidMount() {
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.RASIPALAN_PAGE, { story: get(this.props, ["data", "story"], {}) });
    PGAD.loadScript();
    DeepBI.registerPageView({ story: get(this.props, ["data", "story"], {}) });
  }

  render() {
    const data = get(this.props, ["data"], null);
    const dateInTamil = getDateInTamil(get(data, ["story", "last-published-at"], ""));
    const summary = get(data, ["story", "cards", 0], {});
    const headline = get(data, ["story", "headline"], "Today's Rasi Palan");
    const zodiacCards = get(data, ["story", "cards"], []).slice(1);
    const story = get(data, ["story"], {});
    const subMenu = get(data, ["menuData"], {});
    const almanac = get(data, ["almanac"], []) || [];
    const zodiacSlug = get(data, ["zodiacSlug"], "mesha");
    const rasipalanSlug = get(data, ["rasipalanSlug"], "rasipalan");
    const allZodiacs = data.zodiacs.filter(zodiac => zodiac.en_name === zodiacSlug);
    const displayName = get(allZodiacs, [0, "display_name"], "");
    const zodiacType = get(allZodiacs, [0, "type"], "");
    const zodiacEnName = get(allZodiacs, [0, "en_name"], "");
    const almanacTRs = almanac.map(({ key, displayName, value }) => (
      <tr key={key} className={styles.almanac__entity}>
        <th>{displayName}</th>
        <td>{value}</td>
      </tr>
    ));

    const config = get(this.props, ["config"], {});

    const customHeadLine =
      rasipalanSlug === "rasipalan"
        ? `இன்றைய ${displayName} ராசிபலன் (${zodiacEnName} Rasi Palan) - ${dateInTamil.month} ${dateInTamil.date}, ${
            dateInTamil.year
          } ${dateInTamil.week}`
        : rasipalanSlug === "weekly-rasipalan"
          ? `வாராந்திர ${displayName} ராசிபலன் - ${zodiacType} Weekly Horoscope in Tamil`
          : `மாதந்திர ${displayName} ராசி பலன் -  ${zodiacType} Monthly Horoscope`;

    const renderSocialMedia = (className = "", stickyShare = false, rasipalanShare = true) => (
      <SocialShare
        className={className}
        template={SocialShareTemplate}
        story={story}
        fullUrl={story.url}
        title={story.headline}
        handleClickView={this.handleClickView}
        stickyShare={stickyShare}
        rasipalanShare={rasipalanShare}
        hashtags={
          story.tags &&
          story.tags
            .filter(tag => tag !== null)
            .map(tag => tag.name)
            .toString()
        }
        storyId={story.id}
      />
    );

    return (
      <div className={`${styles["page"]} main-page`}>
        <div />
        <div>
          {subMenu ? (
            <Navbar
              menuGroup={subMenu}
              slug={"spiritual"}
              className={`${styles["submenu"]} ${"container-full-mobile"}`}
              communityColor={subMenu.bgColor}
            />
          ) : null}
          <div className="container">
            <ul className={`${styles.breadcrumbs}`} itemScope itemType="http://schema.org/BreadcrumbList">
              <li
                className={styles.breadcrumb}
                itemProp="itemListElement"
                itemScope
                itemType="http://schema.org/ListItem"
              >
                <WithHostUrl>
                  {({ primaryHostUrl }) => (
                    <Link aria-label={config["publisher-name"]} href={primaryHostUrl} itemprop="item">
                      <span itemProp="name">{config["publisher-name"]}</span>
                    </Link>
                  )}
                </WithHostUrl>
                <meta itemProp="position" content={1} />
              </li>
              <li
                className={styles.breadcrumb}
                itemProp="itemListElement"
                itemScope
                itemType="http://schema.org/ListItem"
              >
                <Link
                  aria-label={`${"Navigate to "} ${rasipalanSlug}`}
                  href={`/horoscope/${rasipalanSlug}`}
                  itemprop="item"
                >
                  <span itemProp="name">{rasipalanSlug.replace(/-/g, " ")}</span>
                </Link>
                <meta itemProp="position" content={2} />
              </li>
              <li
                className={styles.breadcrumb}
                itemProp="itemListElement"
                itemScope
                itemType="http://schema.org/ListItem"
              >
                <Link aria-label={`${"Navigate to "} ${zodiacEnName}`} href={zodiacEnName} itemprop="item">
                  <span itemProp="name">{zodiacEnName}</span>
                </Link>
                <meta itemProp="position" content={3} />
              </li>
            </ul>
            <div className={styles.rasipalan_header}>
              <h1 className={styles.headline}>
                {customHeadLine}
                <div>{renderSocialMedia()}</div>
              </h1>
              <div className={styles.vikatan_playbanner}>
                <a
                  href="https://www.vikatan.com/vikatan-play/daily-rasi-palan?pfrom=rasipalan-page"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://media.vikatan.com/vikatan/2025-07-01/19h4gmy5/Listenaudiorasipalan.png"
                    // className="hidden-mobile"
                  />
                </a>
              </div>
            </div>

            <div className={styles["rasipalan__base"]}>
              <div className={`${styles.rasipalan__row}`}>
                <div className={styles.rasipalan__date}>
                  {dateInTamil && (
                    <React.Fragment>
                      <span className={styles.rasipalan__date_dd}>{dateInTamil.date}</span>
                      <span className={styles.rasipalan__date_month}>{dateInTamil.month}</span>
                      <span className={styles.rasipalan__date_yyyy}>{dateInTamil.year}</span>
                    </React.Fragment>
                  )}
                </div>
                <div className={styles.rasipalan__summary}>
                  <div>
                    {summary["story-elements"].map(element => (
                      <StoryElement card={summary} element={element} key={element.id} />
                    ))}
                    <div className={styles["updated-socialshare"]}>
                      <div className={styles.published_date}>
                        {story["last-published-at"] && (
                          <span className={styles["updated"]}>
                            Last Updated:
                            <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                              {humanizeDate(
                                story["last-published-at"],
                                this.state.showRelativeTime ? "relative" : "absolute"
                              )}
                            </time>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <Media query="(max-width:767px)">
                    <PGAdwithAd
                      adId={`Vikatan2023_Mobile_AP_ATF_336x280`}
                      adSize={[[336, 280], [300, 250]]}
                      minHeight={280}
                      adDivId="div-ad-desk-3849069-877415-2"
                      class="ad_300_250"
                      story={story}
                    />
                  </Media>
                </div>
                <aside className={styles.rasipalan__sidebar}>
                  <button
                    title="toggle dropdown"
                    aria-label="toggle dropdown"
                    role="button"
                    className={`hidden-desktop ${styles["dropdown-button"]}`}
                    onClick={this.toggleDropdown}
                  >
                    <div className={`${styles.sidebar__dropdown_heading_wrapper}`}>
                      <h3 className={styles.sidebar__dropdown_heading}>{displayName}</h3>
                      <Icon
                        type={this.state.isDropdownOpen ? "angle-up" : "angle-down"}
                        className={styles.sidebar__expand_collapse}
                      />
                    </div>
                  </button>
                  <SideBar
                    zodiacs={data.zodiacs}
                    selectedZodiac={zodiacSlug}
                    rasipalanSlug={rasipalanSlug}
                    className={!this.state.isDropdownOpen ? styles.sidebar__collapse : styles.sidebar__expand}
                  />
                </aside>
                <div className={styles.rasipalan__content}>
                  <div className={styles.submenu}>
                    <Link
                      href={`https://www.vikatan.com/horoscope/rasipalan/${zodiacSlug}`}
                      className={rasipalanSlug === "rasipalan" && styles.active}
                    >
                      தின பலன்
                    </Link>
                    <Link
                      href={`https://www.vikatan.com/horoscope/weekly-rasipalan/${zodiacSlug}`}
                      className={rasipalanSlug === "weekly-rasipalan" && styles.active}
                    >
                      வார பலன்
                    </Link>
                    <Link
                      href={`https://www.vikatan.com/horoscope/monthly-rasipalan/${zodiacSlug}`}
                      className={rasipalanSlug === "monthly-rasipalan" && styles.active}
                    >
                      மாத பலன்
                    </Link>
                  </div>
                  <div className={styles.rasipalan__zodiac_active}>
                    <ZodiacIcon type={zodiacType} className={styles.rasipalan__big_icon} hoverDefault={true} />
                    {data.zodiacs.filter(zodiac => zodiac.en_name === zodiacSlug).map(zodiac => (
                      <h2 className={styles.zodiac__display_name} key={zodiac.type}>
                        {zodiac.display_name} ராசி பலன்
                      </h2>
                    ))}
                  </div>
                  {zodiacCards.map((card, index) => {
                    if (data.zodiacs[index].en_name === zodiacSlug) {
                      return (
                        <ZodiacCard
                          key={card.id}
                          className={`${styles["rasipalan_zodiac-card"]}`}
                          card={card}
                          story={data.story}
                          config={config}
                        />
                      );
                    }
                  })}
                </div>
                <aside className={styles.rasipalan__aside}>
                  <Media query="(min-width:768px)">
                    <PGAdwithAd
                      adId={`Vikatan2023_Desktop_AP_RightATF_336x280`}
                      adSize={[[336, 280], [300, 250]]}
                      minHeight={280}
                      adDivId="div-ad-desk-3849069-345-2"
                      class="ad_300_250"
                      story={story}
                    />
                  </Media>
                  <Media query="(max-width:768px)">
                    <PGAdwithAd
                      adId={`Vikatan2023_Mobile_AP_MID2_336x280`}
                      adSize={[[336, 280], [300, 250]]}
                      minHeight={280}
                      adDivId="div-ad-desk-3849069-4456-2"
                      class="ad_300_250"
                      story={story}
                    />
                  </Media>
                  {almanacTRs.length > 0 &&
                    headline === "இன்றைய ராசிபலன்" && (
                      <div className={styles.rasipalan__almanac}>
                        <h2 className={styles.almanac__headline}>{ALMANAC_HEADLINE}</h2>
                        <table className={styles.almanac__table}>
                          <tbody>{almanacTRs}</tbody>
                        </table>
                      </div>
                    )}
                  <PGAdwithAd
                    adId={`Vikatan2023_Desktop_AP_MID2_336x280`}
                    adSize={[[336, 280], [300, 250]]}
                    minHeight={280}
                    adDivId="div-ad-desk-3849069-230-2"
                    class="ad_300_250"
                    story={story}
                  />
                </aside>
              </div>
              <div className={styles["gurupeyarchi-ad"]}>
                <VikatanSticky placement="bundle" story={story} />
              </div>
            </div>
            <MgidUnderArticleAd />
          </div>
        </div>
        <div />
      </div>
    );
  }
}

const tamilMonthMap = {
  1: "ஜனவரி",
  2: "பிப்ரவரி",
  3: "மார்ச்",
  4: "ஏப்ரல்",
  5: "மே",
  6: "ஜூன்",
  7: "ஜூலை",
  8: "ஆகஸ்ட்",
  9: "செப்டம்பர்",
  10: "அக்டோபர்",
  11: "நவம்பர்",
  12: "டிசம்பர்"
};

const tamilWeekMap = {
  0: "ஞாயிறு",
  1: "திங்கள்",
  2: "செவ்வாய்",
  3: "புதன்",
  4: "வியாழன்",
  5: "வெள்ளி",
  6: "சனி"
};

const getDateInTamil = timeInMillis => {
  if (!timeInMillis) {
    return null;
  }
  const dateObj = new Date(timeInMillis);
  const dateUTC = new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60 * 1000);
  const dateIST = new Date(dateUTC.getTime() + 19800000);

  return {
    date: dateIST.getDate(),
    month: tamilMonthMap[dateIST.getMonth() + 1],
    year: dateIST.getFullYear(),
    week: tamilWeekMap[dateIST.getDay()]
  };
};

const SideBar = ({ zodiacs, rasipalanSlug, selectedZodiac, className }) => {
  const signs = zodiacs.map(zodiac => (
    <Link
      href={`https://www.vikatan.com/horoscope/${rasipalanSlug}/${zodiac.en_name}`}
      key={zodiac.type}
      className={`${styles["sidebar__zodiac"]}`}
    >
      <ZodiacIcon
        type={zodiac.type}
        className={styles["sidebar__zodiac-icon"]}
        hoverDefault={selectedZodiac === zodiac.en_name}
      />
      <h3 className={styles["sidebar__zodiac-name"]}>{zodiac.display_name}</h3>
    </Link>
  ));
  return <div className={`${className} ${styles["sidebar__base"]}`}>{signs}</div>;
};

const ZodiacCard = ({ card, className, story, config }) => {
  let elements = card["story-elements"].map(element => <StoryElement card={card} element={element} key={element.id} />);
  const authors = get(story, ["authors"], {});
  const contributors = get(story, ["contributors"], {});
  const tags = get(story, ["tags"], {});

  return (
    <section className={className}>
      {elements}
      <br />
      <b>Author:</b>
      <AuthorDetail authors={authors} config={config} contributors={contributors} className={styles["author-detail"]} />
      <br />
      <b>Tags:</b>
      <Tags tags={tags} className={styles.tags} />
    </section>
  );
};

ZodiacCard.propTypes = {
  card: PropTypes.any,
  className: PropTypes.string,
  story: PropTypes.shape(),
  config: PropTypes.shape()
};

SideBar.propTypes = {
  zodiacs: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      display_name: PropTypes.string,
      dates: PropTypes.string
    })
  ),
  selectedZodiac: PropTypes.string,
  rasipalanSlug: PropTypes.string,
  className: PropTypes.string
};

RasipalanDetailPage.propTypes = {
  data: PropTypes.shape({
    story: PropTypes.any,
    zodiacs: SideBar.propTypes.zodiacs
  }),
  config: PropTypes.shape({
    contentInsightsId: PropTypes.string
  }),
  rasipalanShare: PropTypes.bool
};

export default RasipalanDetailPage;
